export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  access: {
    tower_id: null,
    unit_id: null,
    visitor_id: null,
    go_in: null,
    go_out: null,
    dweller_people_living_id: null,
    status: true
  },
  accesses: [],
  entity: 'access',
  entities: 'accesses',
  dwellerUnits: [],
  dwellerTowers: [],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  prefixRouter: 'dweller.access'
})



// WEBPACK FOOTER //
// ./src/app/dweller/access/resources/data.js